import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";

interface ConfirmationDialogProps {
  onClose: () => void;
  open: boolean;
  onDelete: () => void;
  userName: string;
}

export const DeleteDialog: React.FC<ConfirmationDialogProps> = (
  props: ConfirmationDialogProps
) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          bgcolor: "#fff",
          width: isMobile ? "auto" : "auto",
        },
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <DialogTitle id="confirm-dialog-title">Confirmar Exclusão</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          Tem certeza que deseja excluir o usuário{" "}
          <strong>{props.userName}</strong>?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancelar</Button>
        <Button onClick={props.onDelete} color="error" variant="contained">
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
};
